import { render, staticRenderFns } from "./CreateTier.vue?vue&type=template&id=75d293d8"
import script from "./CreateTier.vue?vue&type=script&lang=js"
export * from "./CreateTier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports